{
  "CUSTOM_ROLE": {
    "HEADER": "Egyedi szerepkörök",
    "LEARN_MORE": "Tudjon meg többet az egyedi szerepkörökről",
    "DESCRIPTION": "Az egyedi szerepköröket a fiók tulajdonosa vagy adminisztrátora hozza létre. Ezeket a szerepköröket ügynökökhöz rendelheti, hogy meghatározza a hozzáférésüket és jogosultságaikat a fiókon belül. Az egyedi szerepkörök konkrét jogosultságokkal és hozzáférési szintekkel hozhatók létre a szervezet igényei szerint.",
    "HEADER_BTN_TXT": "Egyedi szerepkör hozzáadása",
    "LOADING": "Egyedi szerepkörök betöltése...",
    "SEARCH_404": "Nincs megfelelő elem.",
    "PAYWALL": {
      "TITLE": "Váltson magasabb csomagra az egyedi szerepkörökhöz",
      "AVAILABLE_ON": "Az egyedi szerepkör funkció csak a Business és Enterprise csomagokban érhető el.",
      "UPGRADE_PROMPT": "Váltson magasabb csomagra, hogy hozzáférjen a fejlett funkciókhoz, például a csapatkezeléshez, az automatizáláshoz, az egyéni tulajdonságokhoz és továbbiakhoz.",
      "UPGRADE_NOW": "Váltás most",
      "CANCEL_ANYTIME": "A csomagot bármikor módosíthatja vagy lemondhatja"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Az egyedi szerepkör funkció csak a fizetős csomagokban érhető el.",
      "UPGRADE_PROMPT": "Váltson fizetős csomagra, hogy hozzáférjen a fejlett funkciókhoz, például az auditnaplókhoz, az ügynöki kapacitáshoz és továbbiakhoz.",
      "ASK_ADMIN": "A csomagváltással kapcsolatban forduljon az adminisztrátorhoz."
    },
    "LIST": {
      "404": "Ebben a fiókban nincs elérhető egyedi szerepkör.",
      "TITLE": "Egyedi szerepkörök kezelése",
      "DESC": "Az egyedi szerepköröket a fiók tulajdonosa vagy adminisztrátora hozza létre. Ezeket a szerepköröket ügynökökhöz rendelheti, hogy meghatározza a hozzáférésüket és jogosultságaikat a fiókon belül. Az egyedi szerepkörök konkrét jogosultságokkal és hozzáférési szintekkel hozhatók létre a szervezet igényei szerint.",
      "TABLE_HEADER": {
        "NAME": "Név",
        "DESCRIPTION": "Leírás",
        "PERMISSIONS": "Jogosultságok",
        "USAGE_COUNT": "Használók",
        "ACTIONS": "Műveletek"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Összes beszélgetés kezelése",
      "CONVERSATION_UNASSIGNED_MANAGE": "Nem hozzárendelt és saját beszélgetések kezelése",
      "CONVERSATION_PARTICIPATING_MANAGE": "Részvétellel érintett és saját beszélgetések kezelése",
      "CONTACT_MANAGE": "Kontaktok kezelése",
      "ACCESS_ALL_REPORTS": "Összes jelentés megtekintése",
      "KNOWLEDGE_BASE_MANAGE": "Tudásbázis kezelése",
      "DATA_ASSISTANT_MANAGE": "Adatasszisztens kezelése",
      "CALL_RECORDING_ACCESS": "Hozzáférés az összes hívásfelvételhez"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Név",
        "PLACEHOLDER": "Adjon meg egy nevet.",
        "ERROR": "Név kötelező."
      },
      "DESCRIPTION": {
        "LABEL": "Leírás",
        "PLACEHOLDER": "Adjon meg egy leírást.",
        "ERROR": "Leírás megadása kötelező."
      },
      "PERMISSIONS": {
        "LABEL": "Jogosultságok",
        "ERROR": "A jogosultságok megadása kötelező."
      },
      "CANCEL_BUTTON_TEXT": "Mégse",
      "API": {
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      }
    },
    "ADD": {
      "TITLE": "Egyedi szerepkör hozzáadása",
      "DESC": " Az egyedi szerepkörökkel konkrét jogosultságokkal és hozzáférési szintekkel rendelkező szerepköröket hozhat létre a szervezet igényei szerint.",
      "SUBMIT": "Elküldés",
      "API": {
        "SUCCESS_MESSAGE": "Az egyedi szerepkör sikeresen hozzáadva."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Szerkesztés",
      "TITLE": "Egyedi szerepkör szerkesztése",
      "DESC": " Az egyedi szerepkörökkel konkrét jogosultságokkal és hozzáférési szintekkel rendelkező szerepköröket hozhat létre a szervezet igényei szerint.",
      "SUBMIT": "Frissítés",
      "API": {
        "SUCCESS_MESSAGE": "Az egyedi szerepkör sikeresen frissítve."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Törlés",
      "API": {
        "SUCCESS_MESSAGE": "Az egyedi szerepkör sikeresen törölve.",
        "ERROR_MESSAGE": "Nem sikerült csatlakozni a Woot szerverhez, kérjük próbáld később"
      },
      "CONFIRM": {
        "TITLE": "Törlés megerősítése",
        "MESSAGE": "Biztos abban, hogy törli ",
        "YES": "Igen, törlés ",
        "NO": "Nem, mégse "
      }
    }
  }
}
